import React, { useState } from "react";
import * as Types from "../types/BaseTypes";
import Classification from "../objects/Classification";
import Slider from "./Slider";

import * as ClassImages from "../images/classification";

import { useTransition, animated } from "react-spring";

export default (props: {
  core: Types.Core;
  setCore: Function;
  next: Function;
  prev: Function;
}) => {
  const { core, setCore, next, prev } = props;

  const getSliderLeft = () => {
    switch (core.classification) {
      case Types.Classification.I: {
        return 0;
      }
      case Types.Classification.II: {
        return 1;
      }
      case Types.Classification.III: {
        return 2;
      }
      case Types.Classification.IV: {
        return 3;
      }
      default:
        return 0;
    }
  };

  const [panelDirection, setPanelDirection] = useState(100);
  const newPanelDirection = (input: Types.Classification) => {
    setPanelDirection(core.classification > input ? 100 : -100);
  };

  const transitions = useTransition(core.classification, item => item, {
    from: { transform: "translate3d(" + panelDirection * -1 + "vw,0,0)" },
    enter: { transform: "translate3d(0px,0,0)" },
    leave: {
      transform: "translate3d(" + panelDirection + "vw,0,0)",
      position: "absolute"
    },
    config: {
      mass: 1,
      tension: 80,
      friction: 17,
      velocity: 2,
      precision: 0.001
    }
  });

  return (
    <div className={"page p-classification"}>
      <Slider
        core={{ get: core, set: (e: Types.Core) => setCore(e) }}
        type={core.classification}
        typePrimitive={"classification"}
        data={[
          { value: Types.Classification.I, title: "Class I" },
          { value: Types.Classification.II, title: "Class II" },
          { value: Types.Classification.III, title: "Class III" },
          { value: Types.Classification.IV, title: "Class IV" }
        ]}
        getSliderLeft={() => getSliderLeft()}
        newPanelDirection={(e: any) => newPanelDirection(e)}
      />
      {transitions.map(({ item, props, key }) => (
        <animated.div
          key={key}
          className={"details-panel"}
          style={{ ...props, display: "flex" }}
        >
          <div>
            <span className={"details-colored"}>
              {Classification[item - 1].title}
            </span>
            <br />
            <span className={"details-regular"}>
              {Classification[item - 1].description}
            </span>
          </div>
          <div style={{ minWidth: 180, marginLeft: 30, textAlign: "center" }}>
            {item === 1 && <ClassImages.ClassI />}
            {item === 2 && <ClassImages.ClassII />}
            {item === 3 && <ClassImages.ClassIII />}
            {item === 4 && <ClassImages.ClassIV />}
          </div>
        </animated.div>
      ))}
      <div className="buttons">
        <div onClick={() => prev()}>Back</div>
        <div onClick={() => next()}>Next</div>
      </div>
    </div>
  );
};
